<template>
  <a :href="url" download :class="['fileDownloader', { 'fileDownloader--bigger': bigger }]">
    <span :class="['fileDownloader__icon', `icon-border-${type}`]" />
    <div class="fileDownloader__info">
      <div class="fileDownloader__name">
        {{ name }}
      </div>
      <div class="fileDownloader__size">
        {{ bytesToSize(size) }}
      </div>
    </div>
    <v-button v-if="withButton" class="fileDownloader__button" theme="purple" small-height has-html>
      <span class="fileDownloader__buttonMobile icon-download"> </span>
      <span class="fileDownloader__buttonDesktop">Pobierz plik</span>
    </v-button>
  </a>
</template>

<script>
import VButton from '~/components/VButton';

export default {
  name: 'FileDownloader',
  components: { VButton },
  props: {
    name: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    url: {
      type: String,
      default: '',
    },
    size: {
      type: Number,
      default: undefined,
    },
    withButton: {
      type: Boolean,
      default: false,
    },
    bigger: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    bytesToSize(bytes) {
      const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
      if (bytes === 0) return 'n/a';
      const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
      if (i === 0) return `${bytes} ${sizes[i]}`;
      return `${(bytes / 1024 ** i).toFixed(1)} ${sizes[i]}`;
    },
  },
};
</script>

<style lang="scss">
.fileDownloader {
  display: flex;
  align-items: center;
  $root: &;

  &:before {
    transition: color $trL;
  }

  &:hover {
    @include rwd('tablet', true) {
      #{$root}__icon {
        color: $cSec;

        &:before {
          @include icomoon('border-download');
        }
      }

      #{$root}__button {
        opacity: 1;
      }
    }
  }

  &--bigger {
    #{$root}__icon {
      font-size: 3.7rem;
    }

    #{$root}__name {
      font-size: 1.6rem;
      line-height: 2rem;
      font-weight: 400;
    }

    #{$root}__size {
      font-size: 1.4rem;
      line-height: 1.8rem;
    }
  }

  &__icon {
    position: relative;
    z-index: 1;
    font-size: 2.8rem;
    margin-right: 2rem;
    color: $cAddDark02;
    transition: color $tr;
    display: flex;
    align-items: center;
  }

  &__info {
    position: relative;
    z-index: 1;
  }

  &__name {
    margin-bottom: 0.2rem;
    font-size: 1.4rem;
    line-height: 1.8rem;
    font-weight: 600;
  }

  &__size {
    font-size: 1.3rem;
    line-height: 1.6rem;
    color: $cAddDark02;
  }

  &__button {
    position: relative;
    height: 3.8rem;
    z-index: 1;
    margin-left: auto;
    padding-left: 1.4rem;
    padding-right: 1.4rem;
    transition: opacity $tr;

    @include rwd('tablet', true) {
      opacity: 0;
      height: 4.8rem;
      padding-left: 2rem;
      padding-right: 2rem;
    }
  }

  &__buttonDesktop {
    display: none;

    @include rwd('tablet', true) {
      display: block;
    }
  }

  &__buttonMobile {
    display: block;

    @include rwd('tablet', true) {
      display: none;
    }
  }
}
</style>
